'use client';
import * as S from './styles.ts';
import { TextDropdown, UniversalLink, P } from '@template/components';
import { ChevronDown } from '@template/icons';

type ChildLink = {
  name: string;
  key: string;
  description: string;
};

type Link = {
  name: string;
  key: string;
  description: string;
  icon: string;
  objects: ChildLink[];
};

export interface ISideNavProps {
  links: Link[];
  context: 'domain-names' | 'voip';
}

const SideNav = ({ links, context }: ISideNavProps) => {
  return (
    <S.SideNavWrapper>
      {links.map((link) => (
        <S.SideNavItem key={link.key}>
          <S.IconTextGroup>
            <TextDropdown
              title={link.name}
              expandedDefault={false}
              fullWidth
              smallText
            >
              {link.objects.map((object) => (
                <S.SubItem key={object.key}>
                  <UniversalLink
                    href={`/${context}/api-docs/${link.key}/${object.key}`}
                    {...{
                      scroll: false,
                    }}
                  >
                    <P $small>{object.name}</P>
                  </UniversalLink>
                </S.SubItem>
              ))}
            </TextDropdown>
          </S.IconTextGroup>
        </S.SideNavItem>
      ))}
    </S.SideNavWrapper>
  );
};

export default SideNav;
